// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"37de36fb","650":"809ffe78","787":"a542a446","808":"b87c6360","857":"a1ebed3e"}[chunkId] + ".chunk.js";
};